import { Component, Inject, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { PaginationComponent } from '../../../pagination/pagination.component';
import { TranslatorService } from '../../../../services/translator_service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResponsiveService } from '../../../../services/responsive.service';
import { ApiService } from '../../../../web-services/api/api.service';
import { ApiStore } from '../../../../web-services/api/api.store';
import { ApiQuery } from '../../../../web-services/api/api.query';
import _ from 'lodash';

@Component({
  selector: 'app-undo-delete-events',
  standalone: true,
  imports: [TranslateModule, RTLDivDirectiveDirective,CommonModule,MatTableModule,MatSortModule,PaginationComponent],
  templateUrl: './undo-delete-events.component.html',
  styleUrl: './undo-delete-events.component.scss'
})
export class UndoDeleteEventsComponent {
  currentLang;
  translationsObj;
  isMobile: Boolean;
  startIndexTableData = 0;
  endIndexTableData = 4;
  filteredData:Array<object> = [];
	@ViewChild(MatSort,{static: false}) sort: MatSort;
  dataSource = new MatTableDataSource<any>();
  binCollectionData:Array<object> = [];
  displayedColumns = ['name','clearing','address'];
  
  constructor(private translator: TranslatorService,private dialogRef: MatDialogRef<UndoDeleteEventsComponent>, 
    private responsiveService: ResponsiveService,@Inject(MAT_DIALOG_DATA) public data: any,
    private apiService:ApiService,private apiStore:ApiStore,private apiQuery:ApiQuery) {
      this.dialogRef.disableClose = true;
      this.translator.currentLangEmitter$
      .subscribe(async value=>{						
        this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
        this.currentLang = value;	
      });
  }

  ngOnInit() {       
    this.onResize();
    this.responsiveService.checkWidth();
		this.binCollectionData = this.data.items;
		this.updateTableData();
  }

  onResize() {
    this.responsiveService.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  closeModal = () => {
    this.dialogRef.close();
  }

  applyChanges = () => {
    let insertRequest = {
      collection_status:1
    };

    let collectionsIDs = [];
    _.each(this.data.items, (item) => {
      collectionsIDs.push([Number(item.collection_id),0]);
    });  

    insertRequest["collection_id_list"] = collectionsIDs;
    this.apiService.insertCollectionParams(insertRequest).subscribe((v:any) => {
      let request = {
        site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
        start_date : sessionStorage.getItem("collectionsMinDate"),
        end_date : sessionStorage.getItem("collectionsMaxDate")
      }
      let removedCollectionsStatsRequest = {
        site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
        start_date : sessionStorage.getItem("collectionsMinDate"),
        end_date : sessionStorage.getItem("collectionsMaxDate")
      }
      this.apiStore.update({ allCollectionsStats: [] });
      this.apiStore.update({ collectionsStatsInCollections: [] });
      this.apiService.getfilteredBinsCollectionsStats(request,5,JSON.parse(sessionStorage.getItem("chosenSites")));
      this.apiService.RemovedSuspectedCollections(removedCollectionsStatsRequest);
      this.apiService.getUnApprovedAndDeletedSuspectedAsCollectionEvents(removedCollectionsStatsRequest);
    });
    this.closeModal();
  }

  private updateTableData(): void {
    const tableData = [];
    const tempSearch = new MatTableDataSource<any>(this.binCollectionData || []);
    this.filteredData = tempSearch.filteredData;
    for (let index = this.startIndexTableData; index <= this.endIndexTableData; index++) {
      if (tempSearch.filteredData[index]) {
        tableData.push(tempSearch.filteredData[index]);
      }
    }
    this.dataSource = tableData.length > 0 ? new MatTableDataSource<any>(tableData) : new MatTableDataSource<any>([]);		
  }

  sortData(sort: Sort) {    
    const data = this.binCollectionData.slice();    
		if (!sort.active || sort.direction === '') {
			this.binCollectionData = data;
			this.updateTableData();
			return;
		}
		this.binCollectionData = data.sort((a, b) => {
			const isAsc = sort.direction === 'asc';
			return sort.active ? this.compare(a[sort.active], b[sort.active], isAsc) : 0;
		});
		this.updateTableData();
  }

  compare(a, b, isAsc) {
		return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onPageChange = (dataTableIndexes: any) => {
		this.startIndexTableData = dataTableIndexes.startIndex;
		this.endIndexTableData = dataTableIndexes.endIndex;
		this.updateTableData();
  }
}
